module.exports = __webpack_public_path__ + "static/media/tipsAudio.30414fc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/tipsAudio.mp3
// module id = mrC2
// module chunks = 21